import React from 'react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { CTA_LABEL } from '../data/content';
export function FinalCtaSection() {
  return <section className="w-full bg-white px-4 py-9 sm:px-6 sm:py-12" data-id="element-62" data-mp="3qtjcosh883zs">
      <div className="mx-auto max-w-xl text-center" data-id="element-63" data-mp="3quawl61goda8">
        <h2 className="font-display text-[1.2rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-2xl" data-id="element-64" data-mp="3vsvzxec0fd2w">
          Puedes seguir empezando de cero…{' '}
          <span className="text-accent" data-id="element-65" data-mp="333yi1cbpniao">o puedes empezar con un plan.</span>
        </h2>

        <p className="mx-auto mt-2.5 max-w-lg text-[0.85rem] leading-snug text-gray-600 sm:text-base" data-id="element-66" data-mp="331m3l955vq2d">
          No necesitas hacerlo perfecto ni aprender todo sobre metabolismo. Solo
          necesitas saber qué hacer primero y cuál es el siguiente paso.
        </p>

        <p className="mt-2.5 font-display text-[0.95rem] font-extrabold uppercase leading-snug text-brand sm:text-lg" data-id="element-67" data-mp="2fduqw4fplb0k">
          Metabolismo Reset te entrega esa ruta.
        </p>

        <div className="mx-auto mt-4 max-w-md rounded-xl border border-brand/15 bg-brand-soft px-4 py-3" data-id="element-68" data-mp="2dayqxvd8185h">
          <p className="text-[0.8rem] font-medium leading-snug text-brand-deep sm:text-sm" data-id="element-69" data-mp="28e8b995bwekl">
            6 tomos + 5 recursos extra + Plan Maestro 30 días
          </p>
          <p className="mt-0.5 font-display text-base font-extrabold uppercase tracking-wide text-brand-deep sm:text-lg" data-id="element-70" data-mp="1ynnfdth1ho5d">
            USD 12.99 · Pago único
          </p>
        </div>

        <div className="mx-auto mt-4 max-w-md" data-id="element-71" data-mp="1pmfi9eq9etcv">
          <CtaButton href="#precio" location="cierre" data-id="element-72" data-mp="1plmkv4d6xg7e">
            {CTA_LABEL}
          </CtaButton>
          <Reassurance className="mt-2.5" items={['Acceso inmediato', '100% digital', 'Garantía de 7 días']} data-id="element-73" data-mp="1ko4aranfsuxt" />
        </div>
      </div>
    </section>;
}